module.exports = __webpack_public_path__ + "static/media/print&writing_recog_video.98c9b7fc.mp4";